var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBg5Desktop({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1400,
    height: 400,
    viewBox: "0 0 1400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_350_99442)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 340.948,
    cy: 640.358,
    rx: 340.948,
    ry: 640.358,
    transform: "matrix(0.697674 0.716415 -0.683113 0.730313 1553.33 -348.572)",
    fill: "url(#paint0_linear_350_99442)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_350_99442",
    x: 483.738,
    y: -536.367,
    width: 1740.05,
    height: 1799.43,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 186,
    result: "effect1_foregroundBlur_350_99442"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_350_99442",
    x1: 340.948,
    y1: 0,
    x2: 340.948,
    y2: 1280.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#22D695"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22D695",
    stopOpacity: 0.59
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg5Desktop);
export default __webpack_public_path__ + "static/media/bg5-desktop.51fcce5cf0fdf6fbe3e68e108748f52f.svg";
export { ForwardRef as ReactComponent };